export default __webpack_public_path__ + "static/media/CW__3478.59f0f970.jpg";